import React from 'react'

interface SeparatorProps extends React.HtmlHTMLAttributes<HTMLDivElement>{
  title?:string;
  variant?: "dashed" | "solid",
  width?: number;
}

function Separator({...props}:SeparatorProps) {
  return (
    <div style={{position:"relative",lineHeight: 0,...props.style}}>
      {props.variant !== "solid"
        ? (
          <svg height="1px" width="100%">
            <g fill="none" stroke="#0C8188" strokeWidth="2px">
              <path strokeDasharray="3,3" d="M-1.55 0 l9999 0" />
            </g>
          </svg>
        )
        : (
          <div className='hdn_separator' style={{borderStyle:props.variant, borderWidth: `${props?.width ?? 1}px`}}/>
        )
      }
      {props.title && <div className='hdn_separator__title-wrapper'>
        <div style={{display:'flex', alignContent:"center", justifyContent:"center"}}>
          <p className='m-0'>{props.title}</p>
        </div>
      </div>}
    </div>
  )
}

export default Separator